import { apiClient } from './api';
import type {
  GetCompanyResponse,
  GetAllCompaniesApiRequest,
} from '@momentum/types';

export const companiesService = {
  async getAllCompanies(
    params: GetAllCompaniesApiRequest = {}
  ): Promise<GetCompanyResponse> {
    const queryParams = new URLSearchParams();

    if (params.isActive !== undefined)
      queryParams.append('isActive', params.isActive.toString());

    if (params.isDeleted !== undefined)
      queryParams.append('isDeleted', params.isDeleted.toString());

    const query = queryParams.toString();

    return (await apiClient.get(`/companies${query ? `?${query}` : ''}`)).data;
  },
};
